import { graphql } from '@/gql';
import { mutationExecute } from '@/Utils/graphqlAPI';

export const sendFreeTrialReminder = async ({ phoneNumber, purpose }: { phoneNumber: string; purpose: string }) => {
  const response = await mutationExecute({
    variables: {
      phoneNumber,
      purpose,
    },
    mutation: graphql(`
      mutation SendFreeTrialReminder($phoneNumber: String!, $purpose: String!) {
        sendFreeTrialReminder(phoneNumber: $phoneNumber, purpose: $purpose)
      }
    `),
  });

  return response.data?.sendFreeTrialReminder ?? false;
};
